import { Container, Stack, Typography, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import GoBack from "../GoBack";
import GridLayout from "../GridLayout";
import Navbar from "../Navbar";
import PostBrowser from "../PostBrowser";
import Sidebar from "../Sidebar";

const SearchView = () => {
  return (
    <Box sx={{ backgroundColor: "#F5F5F5", minHeight: "100vh" }}>
      <Navbar />
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <GridLayout
          left={
            <Stack spacing={2}>
              <PostBrowser createPost contentType="posts" />
            </Stack>
          }
          right={<Sidebar />}
        />
      </Container>
    </Box>
  );
};

export default SearchView;
